import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DateRangePicker } from "react-date-range";
import SearchIcon from "@mui/icons-material/Search";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import { useNavigate } from "react-router-dom";
import filterIcon from "../../Icons/filterIcon.png";
import ExcelExport from "../../components/ExcelExport/ExcelExportAccounts";
import { useLocation } from "react-router-dom";
import Wrapper from "../../components/UI/Wrapper";
import ReimbursedIcon from "../../Icons/Reimbursed.png";
import PettyCashIcon from "../../Icons/PettyCash.png";
import BalanceIcon from "../../Icons/Balance.png";
import AddIcon from '@mui/icons-material/Add';

const PettyCashStatement = () => {
    const [userDetailResponse, setUserDetailResponse] = useState([]);
    const [employeeDetailResponse, setEmployeeDetailResponse] = useState(['']);
    const [expenseDescription, setExpenseDescription] = useState([]);
    const [employeeCashSummary, setEmployeeCashSummary] = useState({});
    const navigate = useNavigate();
    const [showForm, setShowForm] = useState(false);
    const baseAPI = process.env.REACT_APP_API_URL;
    const storedToken = JSON.parse(localStorage.getItem("token"));
    const location = useLocation();
    const fileInputRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    // ── NEW: default from_date = 1st of current month, to_date = today ──
    const getDefaultFromDate = () => {
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        return firstDay.toISOString().split("T")[0]; // "YYYY-MM-DD"
    };

    const getDefaultToDate = () => {
        return new Date().toISOString().split("T")[0]; // today
    };

    const [fromDate, setFromDate] = useState(getDefaultFromDate());
    const [toDate, setToDate] = useState(getDefaultToDate());

    useEffect(() => {
        fetchExpenseMasterData();
    }, []); // on mount with default dates

    const [updatedFormData, setUpdatedFormData] = useState({
        Relocation_Id: "",
        Description: "",
        Expense_Type: "",
        Job_Id: null,
        Document: "",
        expense_date: "",
        expense_amount: "",
        expense_category: "0",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!updatedFormData.expense_amount || updatedFormData.Expense_Type === "0") {
            alert("Please enter Amount and select an Expense Type.");
            return;
        }
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (storedToken) {
            try {
                const response = await axios.post(
                    `${baseAPI}Userpost/AddFieldOpsExpense?ExpenseId=0`,
                    updatedFormData,
                    {
                        headers: {
                            Authorization: `Bearer ${storedToken}`,
                        },
                    }
                );
                alert("Expense successfully added");
                setUpdatedFormData({
                    ...updatedFormData,
                    Relocation_Id: "",
                    Description: "",
                    Expense_Type: "",
                    Job_Id: null,
                    Document: "",
                    expense_date: "",
                    expense_amount: "",
                    expense_category: "0",
                });
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
                setShowForm(false);
                fetchExpenseMasterData();
            } catch (error) {
                console.error("Error posting data:", error);
            }
        }
    };

    const handleChange = (type, e) => {
        const { name, value, files } = e.target;

        if (name === "Document") {
            const file = files[0];
            getUpdatedDocument(file, name);
            return;
        }

        let updatedForm = {
            ...updatedFormData,
            [name]: value,
        };

        if (name === "Expense_Type") {
            const selectedExpense = expenseDescription.find(
                (exp) => exp.expense_description_id.toString() === value
            );
            if (selectedExpense) {
                updatedForm.expense_category = selectedExpense.expense_category_id || "0";
            }
        }
        setUpdatedFormData(updatedForm);
    };

    function getUpdatedDocument(file, name) {
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const imageData = reader.result;
                setUpdatedFormData({
                    ...updatedFormData,
                    [name]: imageData,
                });
            };
            reader.readAsDataURL(file);
        }
    }

    const fetchExpenseMasterData = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${storedToken}`,
                "Content-Type": "application/json",
            };

            const [
                expenseDescriptionRes,
                UserDetailRes,
                EmployeDetailRes,
                EmployeeCashSummaryRes,
            ] = await Promise.all([
                axios.get(
                    `${baseAPI}adminGet/GetExpenseDescriptions?expense_type=2&expense_category=0`,
                    { headers }
                ),

                // ── CHANGED: GetPettyCashBalancesheet → GetPettyCashDetailReport ──
                // passing from_date and to_date as query params
                axios.get(
                    `${baseAPI}userget/GetPettyCashDetailReport?employee_id=&from_date=${fromDate}&to_date=${toDate}`,
                    { headers }
                ),

                axios.get(`${baseAPI}adminget/GETUserDetail`, { headers }),

                // ── CHANGED: GetEmployeeCashSummary → GetPettyCashSummary ──
                // passing from_date and to_date as query params
                axios.get(
                    `${baseAPI}userget/GetPettyCashSummary?employee_id=&from_date=${fromDate}&to_date=${toDate}`,
                    { headers }
                ),
            ]);

            setExpenseDescription(expenseDescriptionRes.data.data);
            setUserDetailResponse(UserDetailRes.data.data);
            setEmployeeDetailResponse(EmployeDetailRes.data.data[0]);
            setEmployeeCashSummary(EmployeeCashSummaryRes.data.data[0]);

        } catch (error) {
            console.error("Error fetching master data:", error);
        }
    };

    // ── NEW: called when user clicks FILTER button ──
    const handleFilter = () => {
        fetchExpenseMasterData();
    };


    return (
        <div>
            <div className="app-container-viewLeadDetails">
                <MiniDrawer />
                <div
                    style={{ overflowX: "hidden" }}
                    className="container-fluid container-viewLeadDetails"
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "1rem",
                        }}
                        className="country-header"
                    >
                        <div>
                            <h1 style={{ fontSize: "24px" }}>
                                <b> Statement of Accounts </b> | <HomeOutlinedIcon /> &gt;
                                <a style={{ cursor: "pointer" }} onClick={() => navigate("")}>
                                    Operations{" "}
                                </a>
                                <span style={{ fontSize: "20px" }}>&gt; Reports</span>{" "}
                                <span style={{ fontSize: "20px" }}>&gt; Statement</span>
                            </h1>
                        </div>
                    </div>

                    <div>
                        <div className="container-fluid px-3 py-2">

                            {/* ── Summary Card ── */}
                            <Wrapper
                                className="LeadDetails px-0 pettycashHistory-bgcolor"
                                style={{ border: "1px solid #5B489D", background: "#F0EBFF" }}
                            >
                                <div className="row">
                                    <div style={{ borderRight: "2px solid #000000" }} className="col-4 px-0">
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <img className="img-fluid" src={ReimbursedIcon} />
                                            <div className="px-4">
                                                <h6 style={{ fontWeight: "bold", color: "black" }}>
                                                    Total Cash Received
                                                </h6>
                                                <h5 style={{ color: "#5B489D", fontWeight: "bold" }}>
                                                    {/* ── CHANGED: TotalCashReceived_Current from new API ── */}
                                                    ₹ {employeeCashSummary.TotalCashReceived_Current || 0}
                                                </h5>
                                                <h6>
                                                    Last Month:{" "}
                                                    <span style={{ color: "#5B489D", fontWeight: "bold" }}>
                                                        {/* ── CHANGED: TotalCashReceived_LastMonth from new API ── */}
                                                        ₹ {employeeCashSummary.TotalCashReceived_LastMonth || 0}
                                                    </span>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ borderRight: "2px solid #000000" }} className="col-4 px-0">
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <img className="img-fluid" src={PettyCashIcon} />
                                            <div className="px-4">
                                                <h6 style={{ fontWeight: "bold", color: "black" }}>
                                                    Total Expense Done
                                                </h6>
                                                <h5 style={{ color: "#5B489D", fontWeight: "bold" }}>
                                                    {/* ── CHANGED: TotalExpensesDone_Current from new API ── */}
                                                    ₹ {employeeCashSummary.TotalExpensesDone_Current || 0}
                                                </h5>
                                                <h6>
                                                    Last Month:{" "}
                                                    <span style={{ color: "#5B489D", fontWeight: "bold" }}>
                                                        {/* ── CHANGED: TotalExpensesDone_LastMonth from new API ── */}
                                                        ₹ {employeeCashSummary.TotalExpensesDone_LastMonth || 0}
                                                    </span>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-4 px-0">
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <img className="img-fluid" src={BalanceIcon} />
                                            <div className="px-4">
                                                <h6 style={{ fontWeight: "bold", color: "black" }}>
                                                    Current Balance
                                                </h6>
                                                <h5 style={{ color: "#5B489D", fontWeight: "bold" }}>
                                                    {/* ── CHANGED: CurrentBalance from new API ── */}
                                                    ₹ {employeeCashSummary.CurrentBalance || 0}
                                                </h5>
                                                <h6>
                                                    Last Month:{" "}
                                                    <span style={{ color: "#5B489D", fontWeight: "bold" }}>
                                                        {/* ── CHANGED: CurrentBalance_LastMonth from new API ── */}
                                                        ₹ {employeeCashSummary.CurrentBalance_LastMonth || 0}
                                                    </span>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Wrapper>

                            <hr style={{ marginTop: "20px", padding: "0px", marginBottom: "30px" }} />

                            {/* ── Filter Row — NEW date pickers wired to state ── */}
                            <div className="row">
                                <div className="col-12" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    </div>

                                    <div style={{ textAlign: "end" }}>
                                        <button
                                            className="border py-2 rounded-md"
                                            style={{ marginRight: "7px" }}
                                            onClick={() => setShowForm(prev => !prev)}
                                        >
                                            <AddIcon className="icon" />
                                            {showForm ? "Cancel" : "Add Expense"}
                                        </button>
                                        <button className="border py-2 rounded-md" style={{ marginRight: "7px" }}>
                                            ⬇ Download Excel
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <hr style={{ marginTop: "10px", padding: "0px", marginBottom: "-10px" }} />
                            <br />

                            {/* ── Add Expense Form (unchanged) ── */}
                            {showForm && (
                                <>
                                    <Wrapper className="ViewLeadDetails">
                                        <div style={{ MarginTop: "20px" }}>
                                            <h2
                                                className="Venderheading"
                                                style={{ fontSize: "22px", paddingLeft: "16px", paddingTop: "7px" }}
                                            >
                                                Add Expense
                                            </h2>
                                            <div className="row">
                                                <div className="col-3">
                                                    <label style={{ color: "#6a6a6a", fontWeight: "bold" }}>
                                                        Date of Expense
                                                    </label>
                                                    <input
                                                        type="date"
                                                        style={{
                                                            border: "1px solid #5b489d", width: "100%",
                                                            padding: "12px", borderRadius: "6px",
                                                            marginBottom: "21px", marginTop: "12px",
                                                            height: "45px", color: "#6a6a6a",
                                                        }}
                                                        name="expense_date"
                                                        onChange={(event) => handleChange("insert", event)}
                                                        value={updatedFormData.expense_date}
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <label style={{ color: "#6a6a6a", fontWeight: "bold" }}>
                                                        Description
                                                    </label>
                                                    <select
                                                        style={{
                                                            border: "1px solid #5b489d", width: "100%",
                                                            padding: "12px", borderRadius: "6px",
                                                            marginBottom: "21px", marginTop: "12px",
                                                            height: "45px", color: "#6a6a6a",
                                                        }}
                                                        className="form-control"
                                                        name="Expense_Type"
                                                        onChange={(event) => handleChange("insert", event)}
                                                        required
                                                        value={updatedFormData.Expense_Type}
                                                    >
                                                        <option value="0">Select an option</option>
                                                        {expenseDescription !== null
                                                            ? expenseDescription.map((exp) => (
                                                                <option key={exp.expense_description_id} value={exp.expense_description_id}>
                                                                    {exp.description}
                                                                </option>
                                                            ))
                                                            : null}
                                                    </select>
                                                </div>
                                                <div className="col-3">
                                                    <label style={{ color: "#6a6a6a", fontWeight: "bold" }}>
                                                        Expense Amount
                                                    </label>
                                                    <input
                                                        type="text"
                                                        style={{
                                                            border: "1px solid #5b489d", width: "100%",
                                                            padding: "12px", borderRadius: "6px",
                                                            marginBottom: "21px", marginTop: "12px",
                                                            height: "45px", color: "#6a6a6a",
                                                        }}
                                                        name="expense_amount"
                                                        onChange={(event) => handleChange("insert", event)}
                                                        value={updatedFormData.expense_amount}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-6">
                                                    <label style={{ color: "#6a6a6a", fontWeight: "bold" }}>
                                                        Remark <span>(if Any)</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        style={{
                                                            border: "1px solid #5b489d", width: "100%",
                                                            padding: "12px", borderRadius: "6px",
                                                            marginBottom: "21px", marginTop: "12px",
                                                            height: "45px", color: "#6a6a6a",
                                                        }}
                                                        name="Description"
                                                        onChange={(event) => handleChange("insert", event)}
                                                        value={updatedFormData.Description}
                                                        placeholder="Please Enter*"
                                                        required
                                                    />
                                                </div>
                                                <div className="col-3">
                                                    <label style={{ color: "#6a6a6a", fontWeight: "bold" }}>
                                                        Choose Document
                                                    </label>
                                                    <input
                                                        type="file"
                                                        style={{
                                                            border: "1px solid #5b489d", width: "100%",
                                                            padding: "12px", borderRadius: "6px",
                                                            marginBottom: "21px", marginTop: "12px",
                                                            height: "45px", color: "#6a6a6a",
                                                        }}
                                                        name="Document"
                                                        ref={fileInputRef}
                                                        onChange={(event) => handleChange("insert", event)}
                                                        placeholder="Please Enter*"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <div className="col-12" style={{ textAlign: "-webkit-right" }}>
                                                <button
                                                    style={{ marginRight: "4px", backgroundColor: "#F15843", color: "white" }}
                                                    onClick={() => setShowForm(false)}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={handleSubmit}
                                                    type="submit"
                                                    style={{ backgroundColor: "#5B489D", color: "white" }}
                                                >
                                                    Add +
                                                </button>
                                            </div>
                                        </div>
                                    </Wrapper>
                                    <br />
                                </>
                            )}

                            {/* ── Account Details table (unchanged) ── */}
                            <div className="row pb-3">
                                <div className="col-12">
                                    <h2 className="text-left" style={{ fontSize: "18px", padding: "9px 0 0 16px" }}>
                                        Account Details
                                    </h2>
                                </div>
                                <div style={{ marginTop: "5px", display: "flex" }}>
                                    <table className="leadlist_1 leadlist_2-Ms-table">
                                        <tr className="viewLeadDetailsHeading expenseHeading">
                                            <th><span>Name</span></th>
                                            <td style={{ borderBlock: "1px solid #ccc" }}><span>{employeeDetailResponse.name}</span></td>
                                            <th><span>Department</span></th>
                                            <td style={{ borderBlock: "1px solid #ccc" }}><span>{employeeDetailResponse.Department}</span></td>
                                        </tr>
                                        <tr className="viewLeadDetailsHeading">
                                            <th><span>Designation</span></th>
                                            <td><span>{employeeDetailResponse.Designation}</span></td>
                                            <th><span>Manager's Name</span></th>
                                            <td><span></span></td>
                                        </tr>
                                        <tr className="viewLeadDetailsHeading">
                                            <th><span>Petty Cash Number</span></th>
                                            <td><span>CMP-M2301</span></td>
                                            <th><span>Fixed Amount</span></th>
                                            <td><span>₹ 10,000</span></td>
                                        </tr>
                                        <tr className="viewLeadDetailsHeading">
                                            <th><span>Account Number</span></th>
                                            <td><span>0000000000000000</span></td>
                                            <th><span>IFSC</span></th>
                                            <td><span>--</span></td>
                                        </tr>
                                        <tr className="viewLeadDetailsHeading">
                                            <th><span>Opening Balance</span></th>
                                            <td><span></span></td>
                                            <th><span>Closing Balance</span></th>
                                            <td><span></span></td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                            {/* ── Expense Detail table ── */}
                            <div className="expenseList">
                                <h2
                                    className="Venderheading"
                                    style={{ fontSize: "22px", paddingLeft: "16px", paddingTop: "7px" }}
                                >
                                    Expense Detail
                                </h2>
                                <table style={{ width: "100%" }} className="table_expense">
                                    <thead>
                                        <tr className="expenseListHeading">
                                            <th>S No.</th>
                                            <th>Transaction Date</th>
                                            <th>Lead ID</th>
                                            <th>Vendor</th>
                                            <th>Cash Received</th>
                                            <th>Expense Description</th>
                                            <th>Expense Amount</th>
                                            <th>Current Balance</th>
                                            <th>Additional Remark</th>
                                            <th>Status</th>
                                            <th style={{ textAlign: "center" }}>Document</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userDetailResponse !== null && userDetailResponse.length > 0 ? (
                                            userDetailResponse.map((expense, index) => (
                                                <tr key={index + 1}>
                                                    <td>{index + 1}</td>
                                                    {/* ── CHANGED: column names match new procedure output ── */}
                                                    <td>{expense.Date}</td>
                                                    <td>{expense.LeadID || "-"}</td>
                                                    <td>{expense.Vendor || "-"}</td>
                                                    <td>{expense.CashReceived || "-"}</td>
                                                    <td>{expense.ExpenseDescription || "-"}</td>
                                                    <td
                                                        style={{
                                                            color: expense.ExpenseAmount ? "inherit" : "gray"
                                                        }}
                                                    >
                                                        {expense.ExpenseAmount || "-"}
                                                    </td>
                                                    <td
                                                        style={{
                                                            // ── CHANGED: red color when balance is negative ──
                                                            color: expense.CurrentBalance < 0 ? "red" : "#28a745",
                                                            fontWeight: "bold"
                                                        }}
                                                    >
                                                        ₹ {expense.CurrentBalance}
                                                    </td>
                                                    <td>{expense.Remark || "-"}</td>
                                                    <td>
                                                        <span
                                                            style={{
                                                                backgroundColor: expense.Status === "APPROVED" ? "#28a745" : "#dc3545",
                                                                color: "white",
                                                                padding: "3px 8px",
                                                                borderRadius: "4px",
                                                                fontSize: "12px",
                                                                fontWeight: "bold"
                                                            }}
                                                        >
                                                            {expense.Status}
                                                        </span>
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <button
                                                            className="text-center"
                                                            style={{
                                                                border: "none", width: "37px",
                                                                padding: "0px", height: "36px",
                                                                margin: "6px",
                                                                backgroundColor: "#F1F1F1",
                                                                color: "#6a6a6a",
                                                            }}
                                                        >
                                                            <SearchIcon />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="11">No expenses available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Pagination (unchanged) */}
                                <nav aria-label="Page navigation" style={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
                                    <ul className="pagination">
                                        <li className="page-item">
                                            <a style={{ cursor: "pointer", fontWeight: "bold", color: "#5B489D" }} className="page-link">
                                                Previous
                                            </a>
                                        </li>
                                        <li style={{ backgroundColor: "#5B489D" }} className="page-item active">
                                            <a style={{ backgroundColor: "#5B489D", border: "none" }} className="page-link">1</a>
                                        </li>
                                        <li className="page-item">
                                            <a style={{ cursor: "pointer", color: "#5B489D" }} className="page-link">2</a>
                                        </li>
                                        <li className="page-item">
                                            <a style={{ cursor: "pointer", color: "#5B489D", fontWeight: "bold" }} className="page-link">Next</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PettyCashStatement;